import React, { useEffect, useState, useCallback } from "react";
import { db } from "../firebase";
import {
    collection,
    getDocs,
    addDoc,
    deleteDoc,
    doc,
} from "firebase/firestore";

const RealWorkImages = () => {
    const [images, setImages] = useState([]);
    const [imageUrl, setImageUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const collectionRef = collection(db, "real_work_images");

    const fetchImages = useCallback(async () => {
        try {
            const snapshot = await getDocs(collectionRef);
            const list = snapshot.docs.map((d) => ({
                id: d.id,
                imageUrl: d.data().imageUrl,
            }));
            setImages(list);
        } catch (e) {
            console.error(e);
            setError("Failed to fetch images");
        } finally {
            setLoading(false);
        }
    }, [collectionRef]);

    useEffect(() => {
        fetchImages();
    }, [fetchImages]);

    const handleAddImage = async () => {
        if (!imageUrl.trim()) return;

        try {
            await addDoc(collectionRef, { imageUrl });
            setImageUrl("");
            fetchImages();
        } catch (e) {
            console.error(e);
            setError("Failed to add image");
        }
    };

    const handleDeleteImage = async (id) => {
        try {
            await deleteDoc(doc(db, "real_work_images", id));
            fetchImages();
        } catch (e) {
            console.error(e);
            setError("Failed to delete image");
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center text-gray-500">
                Loading images…
            </div>
        );
    }

    return (
        <div className="h-screen bg-gray-50 p-6 flex flex-col">
            <div className="max-w-6xl mx-auto flex flex-col h-full">
                {/* Header */}
                <div className="mb-6">
                    <h1 className="text-3xl font-bold text-gray-800">
                        Home Carousel Images
                    </h1>
                    <p className="text-sm text-gray-500 mt-1">
                        Manage real work images shown on the home screen
                    </p>
                </div>

                {error && (
                    <div className="mb-4 p-3 bg-red-50 text-red-600 rounded">
                        {error}
                    </div>
                )}

                {/* Add Image Card */}
                <div className="bg-white rounded-lg shadow p-5 mb-8">
                    <h2 className="font-semibold text-gray-700 mb-3">
                        Add New Image
                    </h2>

                    <div className="flex gap-3">
                        <input
                            type="text"
                            placeholder="Paste image URL (1200 × 700 recommended)"
                            className="flex-1 p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={imageUrl}
                            onChange={(e) => setImageUrl(e.target.value)}
                        />
                        <button
                            onClick={handleAddImage}
                            className="bg-blue-600 text-white px-5 rounded hover:bg-blue-700 transition"
                        >
                            Add
                        </button>
                    </div>
                </div>

                {/* Images Grid */}
                {/* Images Grid */}
                <div className="flex-1 overflow-y-auto">
                    {images.length === 0 ? (
                        <div className="text-center text-gray-500 py-20">
                            No images added yet
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pb-6">
                            {images.map((img) => (
                                <div
                                    key={img.id}
                                    className="bg-white rounded-lg shadow p-4 flex gap-4 items-center"
                                >
                                    <img
                                        src={img.imageUrl}
                                        alt="real work"
                                        className="w-40 h-24 object-cover rounded border"
                                    />

                                    <div className="flex-1 overflow-hidden">
                                        <p className="text-sm text-gray-600 truncate">
                                            {img.imageUrl}
                                        </p>
                                    </div>

                                    <button
                                        onClick={() => handleDeleteImage(img.id)}
                                        className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition"
                                    >
                                        Delete
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>


            </div>
        </div>
    );
};

export default RealWorkImages;
